import React from 'react';
import { Redirect } from 'react-router-dom';
import WorkOrderTable from '../WorkOrderTable';
import { TrackedWorkOrderTableEmptyState } from '../WorkOrderTable/emptyState/WorkOrderTableEmptyState';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';
import { FILTER_CONFIG_NAMES, ROLE_TYPES } from '../../utils/DataConstants';
import {
	isWorkOrderLabelsTrackEnabled,
	isWorkOrderRemindersEnabled,
} from '../../data/workOrderStarLabels';
import TrackedReminderGroups, {
	TRACKED_GROUP_PRE_APPLIED_FILTERS,
	TRACKED_PRE_APPLIED_FILTERS,
} from './TrackedReminderGroups';

const STARRED_TAB_FILTERS = BUYER_WO_FILTERS_ORDER.filter(
	(filterName) => filterName !== FILTER_CONFIG_NAMES.STARRED
);

export default function WorkOrdersStarredIndexPage() {
	// The Tracked view is gated behind workorder-labels-track and hidden from tabs/pickers when off;
	// guard the direct route too so /workOrders/overview/starred can't expose it by URL.
	if (!isWorkOrderLabelsTrackEnabled()) {
		return <Redirect to="/buyer/workOrders/overview/active" />;
	}
	// With reminders off, one plain list instead of the Active / Upcoming / Tracked groups.
	const remindersEnabled = isWorkOrderRemindersEnabled();
	return (
		<WorkOrderTable
			handleQueryParams
			preAppliedFilters={
				remindersEnabled ? TRACKED_GROUP_PRE_APPLIED_FILTERS : TRACKED_PRE_APPLIED_FILTERS
			}
			filterConfig={{ filters: STARRED_TAB_FILTERS }}
			renderEmptyState={TrackedWorkOrderTableEmptyState}
			renderBody={
				remindersEnabled
					? (bodyProps) => <TrackedReminderGroups {...bodyProps} userType={ROLE_TYPES.BUYER} />
					: undefined
			}
		/>
	);
}
